import React from 'react';
import { utilsFunction } from '@/helpers/functions/index';
import { APP_MODE_TYPE } from "@/constants/app";

class BlockControl extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		const { name, auth, children } = this.props
    if (name) {
		  return BlockControl.isBlockAction(name, children)
    } else if (typeof auth === 'boolean') {
      return auth ? children : null
    }
    return children
	}

	static isBlockAction(name, defaultValue, newValue) {
		const { block, mode } = utilsFunction.getAllUrlParams(window.location.search)
		if (mode !== APP_MODE_TYPE.EMBEDDED || !block) return defaultValue

		let blockStatus = false
		const data = {
			'trade-portfolio': block === 'trade-portfolio' || block === 'trading',
			'order-table': block === 'order-table' || block === 'order-book' || block === 'order-history' || block === 'trading',
			'right-view': block === 'asset' || block === 'place-order' || block === 'trading',
			'asset-style': block === 'asset',
			'right-view-style': block === 'asset' || block === 'place-order',
			'asset': block === 'asset' || block === 'trading',
			'place-order': block === 'place-order' || block === 'trading',
			'my-account': block === 'my-account',
			'account-balance': block === 'my-account' || block === 'account-balance',
			'account-portfolio': block === 'my-account' || block === 'account-portfolio',
			'transaction-history': block === 'my-account' || block === 'transaction-history',
			'watchlist': block === 'watchlist' || block === 'market',
			'watchlist-style': block === 'watchlist',
			'news': block === 'news' || block === 'market',
			'news-style': block === 'news',
			'quote-details': block === 'quote-details' || block === 'market',
			'quote-details-style': block === 'quote-details',
			'ipo-table' : block  === 'ipo-application' || block === 'ipo-status-enquiry' || block === 'ipo',
			'ipo-application' : block === 'ipo-application' || block === 'ipo',
			'ipo-status-enquiry' : block === 'ipo-status-enquiry' || block === 'ipo',
			'ipo-allotted' : block === 'ipo-allotted' || block === 'ipo',
			'fund-management-container' : block === 'fund-management-container'　|| block === 'cash-manage',
			'fund-management-container-style' : block === 'fund-management-container',
			'cash-table' : block === 'cash-table' || block === 'cash-manage' ||  block === 'cash-dw-enquiry' || block === 'fund-transfer-enquiry',
			'cash-table-style' : block === 'cash-table' || block === 'fund-transfer-enquiry' ||  block === 'cash-dw-enquiry',
			'cash-dw-enquiry' : block === 'cash-dw-enquiry' || block === 'cash-manage',
			'fund-transfer-enquiry' : block === 'fund-transfer-enquiry' || block === 'cash-manage',
		}
		if (typeof data[name] === 'boolean' && data[name]) {
			blockStatus = true
		}
		if (blockStatus) return newValue || defaultValue
		else if (newValue && defaultValue) return defaultValue
		return null
	}

	static initEmbeddedTable(datalist = 'tabHeader') {
		const pathname = this.props.location.pathname.slice(1)
		const { block,mode } = utilsFunction.getAllUrlParams(this.props.location.search)
		if (mode !== APP_MODE_TYPE.EMBEDDED || !block) return;
		if(block === 'ipo' || block ==='cash-manage') return
		let list = block.split(',')
		const data = {
			'trade': {
				titleMaps: { 'order_book_title': 'order-book', 'order_history_title': 'order-history' },
				tableMaps: { 'order_book_title': 'ORDER_BOOK_TABLE', 'order_history_title': 'ORDER_HISTORY_TABLE' }
			},
			'ipo': {
				titleMaps: { 'ipo_application': 'ipo-application', 'ipo_application_status_enquiry': 'ipo-status-enquiry' },
				tableMaps: {'ipo_application': 1, 'ipo_application_status_enquiry': 2}
			},
			'fund-management': {
				titleMaps: { 'cash_dw_enquiry': 'cash-dw-enquiry', 'fund_transfer_enquiry': 'fund-transfer-enquiry' },
				tableMaps: { 'cash_dw_enquiry': 1, 'fund_transfer_enquiry': 2 }
			}
		}

		const { titleMaps, tableMaps } = data[pathname]
			const newData = this.state[datalist].map(item => {
				const block = titleMaps[item.title]
				const key = list.find(name => name === block)
				if (key) {
				  return item
				}
				return null
			  }).filter(Boolean)
			this.setState({ [datalist]: newData })
			const firstTitle = newData[0]?.title
			if (firstTitle && firstTitle !== tableMaps[firstTitle]) {
				if(pathname === 'trade'){
					this.handleChangeOrderTableTab({ main: { title: firstTitle } })
				}else{
					this.setState({ selectedTab: tableMaps[firstTitle] })
				}
			}
	  }
}

export default BlockControl;